import { useText } from "@sveabank/cc-common";
import { Navigate } from "react-router";
import { getBearerToken } from "../utils/storage";

const Root = () => {
	const [t, text] = useText();
	document.title = t(text.appTitle);
	const token = getBearerToken();

	return <Navigate to={token ? "/dashboard" : "/login"} />;
};

export default Root;
